<template>
  <div>
    <ValidationObserver v-if="isAdmin" ref="form" v-slot="{ invalid }">
      <v-card class="d-flex align-center flex-wrap pa-4 flex-column flex-sm-row" style="gap: 15px">
        <h3>Add New:</h3>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <ValidationProvider name="Date" v-slot="{ errors }" :rules="{ required: true }">
              <v-text-field
                :readonly="true"
                style="max-width: 200px"
                label="Date"
                dense
                outlined
                hide-details
                v-model="model.time"
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </template>
          <v-date-picker
            :max="moment().format('YYYY-MM')"
            type="month"
            v-model="model.time"
            @change="menu = false"
          />
        </v-menu>
        <ValidationProvider
          name="Seniority"
          v-slot="{ errors }"
          :rules="{ required: true, decimal: 3 }"
        >
          <v-text-field
            style="max-width: 200px"
            label="Seniority"
            v-model.number="model.seniority"
            hide-details
            outlined
            dense
            :error-messages="errors"
          />
        </ValidationProvider>
        <v-btn color="primary" :disabled="invalid" @click="addItem">Add</v-btn>
      </v-card>
    </ValidationObserver>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-row>
            <v-col cols="4">
              <b>Date</b>
            </v-col>
            <v-col cols="2">
              <b>Seniority</b>
            </v-col>
            <v-col cols="2"> </v-col>
          </v-row>
          <v-divider />
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="item in computedHistory" :key="item.time">
        <v-list-item-content>
          <v-row>
            <v-col cols="4">{{ item.time | moment }}</v-col>
            <v-col cols="2">{{ item.seniority }}</v-col>
            <v-col cols="2">
              <v-btn v-if="isAdmin" small @click="deleteItem(item)" color="error"
                ><v-icon>mdi-trash-can</v-icon> Delete</v-btn
              ></v-col
            >
          </v-row>
          <v-divider />
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!computedHistory || !computedHistory.length" class="text-center">
        <v-row>
          <v-col> No Data </v-col>
        </v-row>
      </v-list-item>
      <!-- <v-pagination class="mt-4" v-model="pageVal" :length="data.pages || 1" /> -->
    </v-list>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  props: {
    value: [],
  },
  data() {
    return {
      menu: false,
      model: {
        time: null,
        seniority: null,
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['isMaster', 'isAdmin', 'isCashier']),
    computedHistory() {
      return this.value.sort(
        (a, b) => moment(b.time).toDate().getTime() - moment(a.time).toDate().getTime(),
      );
    },
  },
  methods: {
    moment,
    addItem() {
      console.log('add item', [
        ...this.value,
        { seniority: this.model.seniority, time: moment(this.model.time).endOf('month').toDate() },
      ]);
      this.$emit('update', [
        ...this.value,
        { seniority: this.model.seniority, time: moment(this.model.time).endOf('month').toDate() },
      ]);
    },
    async deleteItem(item) {
      const confirm = await this.$root.$confirm.open('Confirm', 'confirm to delete?', {
        color: 'red',
      });
      if (!confirm) return;
      this.$emit(
        'update',
        this.value.filter(_item => _item !== item),
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
